// Empty stub module for browser compatibility
export default {};
